export const VANGUARD_ONLY_TEST_LEVEL = "vanguard_only";

/**
 * Contact fixture used only when ?testLevel=vanguard_only so marketers can
 * exercise the order page without typing identity or opening Palyance SEPA.
 */
export const VANGUARD_ONLY_CONTACT = Object.freeze({
  billingEmail: "preview.vanguard@pubfac.test",
  billingFirstName: "Preview",
  billingLastName: "Vanguard",
  billingPhoneNumber: "0600000000",
  billingStreet3: "1 rue de la Preview",
  billingZipCode: "75001",
  billingCity: "Paris",
  billingCountry: "FRA",
  sameAsBilling: true,
  acceptCgv: true,
  acceptCgs: true,
});

/**
 * Prefer the live query string so a sticky MultiLocalStorage testLevel cannot
 * activate preview outside an explicit ?testLevel=vanguard_only URL.
 */
export function isVanguardOnlyPreview() {
  if (typeof window === "undefined") {
    return false;
  }
  const params = new URLSearchParams(window.location.search || "");
  return params.get("testLevel") === VANGUARD_ONLY_TEST_LEVEL;
}

export function getVanguardOnlyContactFixture() {
  return { ...VANGUARD_ONLY_CONTACT };
}
